import { render, staticRenderFns } from "./dniUpload.vue?vue&type=template&id=df6b0784&scoped=true&"
import script from "./dniUpload.vue?vue&type=script&lang=js&"
export * from "./dniUpload.vue?vue&type=script&lang=js&"
import style0 from "./dniUpload.vue?vue&type=style&index=0&id=df6b0784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6b0784",
  null
  
)

export default component.exports